const Card = ({ children, className = '', title, ...props }) => {
    return (
        <div
            className={`bg-white dark:bg-mono-950 border border-mono-200 dark:border-mono-800 rounded-xl shadow-mono p-6 ${className}`}
            {...props}
        >
            {title && <h3 className="text-lg font-semibold text-black dark:text-white mb-4">{title}</h3>}
            {children}
        </div>
    );
};

export default Card;
